<script lang="ts">
  let { items, shown = items.length, cols = 40, size = 5, dark = false, ok = false, label = '' }: { items: { through: boolean }[]; shown?: number; cols?: number; size?: number; dark?: boolean; ok?: boolean; label?: string } = $props();
</script>

<div class="af" class:dark class:ok style="--cols: {cols}; --mcols: {Math.min(cols, 40)}; --size: {size}px; --msize: {cols > 20 ? Math.min(size, 4) : size}px" role="img" aria-label={label}>
  {#each items as o, i}
    <i class:on={i < shown} class:miss={i < shown && o.through}></i>
  {/each}
</div>

<style>
  .af { display: grid; grid-template-columns: repeat(var(--cols), 1fr); gap: calc(var(--size) * 0.7); }
  i { display: block; width: var(--size); height: var(--size); border-radius: 50%; background: var(--border-subtle); transition: background 0.15s; }
  i.on { background: var(--border); }
  i.miss { background: var(--accent-red); }
  @media (max-width: 560px) {
    .af { gap: calc(var(--msize) * 0.6); grid-template-columns: repeat(var(--mcols), 1fr); }
    i { width: var(--msize); height: var(--msize); }
  }
  .dark i { background: rgba(251, 250, 246, 0.08); }
  .dark i.on { background: rgba(251, 250, 246, 0.28); }
  .dark i.miss { background: var(--held-light); }
  .ok i.on { background: var(--accent); }
  .dark.ok i.on { background: var(--gold-light); }
</style>
